import { ItemObject } from '../base/item_object'
import { ItemType } from '../base/types'
import { type TextMessage } from '../i18n'

export class Form extends ItemObject {
  constructor (id: string, title: TextMessage) {
    super(id, ItemType.Form, title)
  }
}
